export default {
    parts: ['termsText', 'termsLink', 'recaptchaText', 'recaptchaLink'],
    baseStyle: ({enabledIDPs, isLoginPage}) => ({
        termsText: {
            textStyle: 'bodyXsRegular',
            textAlign: 'left',
            color: 'gray.700',
            marginTop: enabledIDPs ? {base: '-45px', lg: '-50px'} : 0,
            marginBottom: 0,
            px: isLoginPage ? {base: 4, lg: 0} : 0,
            pr: !isLoginPage ? '1px' : 0
        },
        termsLink: {
            textDecoration: 'underline',
            color: 'gray.700'
        },
        recaptchaText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textTertiary'
        },
        recaptchaLink: {
            textDecoration: 'underline',
            color: 'webTypo.textTertiary'
        }
    })
}